import * as yup from "yup";
import { matchIsValidTel } from "mui-tel-input";
import mobileLengths from "./mobileLengths.json";

// Valid mobile lengths (digits after the country code) for the brand's country,
// e.g. PG -> { min: 8, max: 8, range: "8" }, MY -> { min: 9, max: 10, range: "9-10" }.
// Generated from libphonenumber metadata by scripts/build-mobile-lengths.js.
export const getMobileLengthRange = (country = process.env.REACT_APP_COUNTRY) => {
  const lengths = mobileLengths[country?.toUpperCase()];
  if (!lengths?.length) return { min: undefined, max: undefined, range: "" };

  const min = Math.min(...lengths);
  const max = Math.max(...lengths);
  return { min, max, range: min === max ? `${min}` : `${min}-${max}` };
};

// Shared yup rule for register mobile number fields. matchIsValidTel checks the number
// against the selected country's rules (length + prefix); the range only feeds the message.
export const mobileNumberSchema = (t) =>
  yup
    .string()
    .required(t("validation.mobilenum"))
    .test(
      "validTel",
      t("validation.mobilenumlength", { range: getMobileLengthRange().range }),
      (val) => (val ? matchIsValidTel(val) : false)
    );
